'use strict';

var implementation = require('./implementation');

module.exports = function getPolyfill() {
	return Array.prototype.flatMap || implementation;
};



//////////////////
// WEBPACK FOOTER
// ./~/array.prototype.flatmap/polyfill.js
// module id = 258
// module chunks = 35783957827783 172322841747965